<template>
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 5L0.942651 10L4.07372e-08 9.06804L4.11472 5L3.96377e-07 0.931957L0.942652 4.12046e-08L6 5Z" fill="#30A8FF"/>
  </svg>
</template>
